import React from 'react';
import styled from 'styled-components';
import { Emoji } from 'emoji-mart'

import {PopOut, Close} from 'components';
import {IconInput} from 'features';
import { FaFileAlt } from 'react-icons/fa';

import classes from './PageIcon.module.css'

const Container = styled.div`
    cursor: pointer;
    outline: none;
    display: flex;
    justify-content: center;
    align-items:center;
`

const IconContainer = styled.div`
    display: flex;
    justify-content: ${props => props.alignment ? props.alignment : 'center'};
    align-items: center;
    border: ${props => props.icon ? '0.1rem solid transparent' : null};
    border-radius: 5px;
    padding: ${props => props.padding ? props.padding : null};
    margin: ${props => props.margin ? props.margin : null};
    :hover {
        border: ${props => props.icon ? '0.1rem solid var(--secondary-color)' : null};
    }
`

const Icon = styled.div`
    width: ${props => props.size ? props.size : '1rem'};
    height: ${props => props.size ? props.size : '1rem'};
    font-size: ${props => props.size ? props.size : '1rem'};
    color: var(--text-color);
    display: flex;
    justify-content: center;
    align-items: center;
`

const ImageContainer = styled.div`
    width: ${props => props.size ? props.size : '1rem'};
    height: ${props => props.size ? props.size : '1rem'};
    object-fit: cover;
    // border: 1px solid white;
`

const PageIcon = props => {
    const {
        icon,
        size,
        padding,
        margin,
        alignment,
        defaultIcon
    } = props;

    const selectIconHandler = (icon,type,event) => {
        if(!event){
            props.selectIconHandler(null, null, props.pageID); //To remove icon
        } else {
            props.selectIconHandler(icon, type, props.pageID);
        }
    }

    let iconElement = null;
    if(props.icon) {
        if(props.icon.type === 'emoji'){
            iconElement = <Emoji emoji={icon.value} size={size ? size : '1rem'} native={true}/>
        } else if (icon.type === 'link') {
            iconElement = <ImageContainer size={size ? size : '1rem'}>
                        <img src={icon.value} style={{width:'100%', height:'100%',objectFit:'contain'}}/>
                    </ImageContainer>
        }
        
    } else if (defaultIcon) {
        iconElement = defaultIcon
    } else if (props.disableEmptyIcon) {
        iconElement = <Icon size={props.size}><FaFileAlt className={classes.DefaultIcon}/></Icon>
    } else {
        iconElement = <div className={classes.AddIcon}>Add icon</div>
    }

    return (
        <Container icon={icon}>
            {/* <PopOut trigger='leftClick' element={<IconInput submitHandler={selectIconHandler} pageID={props.pageID}/>}> */}
                <IconContainer icon={icon} padding={padding} margin={margin} alignment={alignment}>
                    {iconElement}
                </IconContainer>
            {/* </PopOut> */}
        </Container>
    )
}

export default PageIcon;